import { QUERY_KEYS } from "../../../../constants/queryKeys";

type Input = {
  keyword: string;
  search: string;
};
type Output = string;
type GetNextQueryQuery = (input: Input) => Output;

export const getNextQuery: GetNextQueryQuery = (input) => {
  const { keyword, search } = input;

  const parameters = new URLSearchParams(search);
  const conditionKeys = Object.values(QUERY_KEYS.SEARCH_CONDITIONS);
  conditionKeys.forEach((key) => {
    parameters.delete(key);
  });
  if (keyword !== "") {
    parameters.set(QUERY_KEYS.SEARCH_CONDITIONS.KEYWORD, keyword);
  }

  return parameters.toString();
};
